import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import {PythonTaskData} from "../../../serviceapi/jobRunnerApi";

interface TestDataDialogProps {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  testData: PythonTaskData;
}

const TestDataDialog = ({
  isVisible,
  setIsVisible,
  testData,
}: TestDataDialogProps) => {
  const headerTemplate = () => {
    return (
      <div className="flex justify-content-start align-items-center gap-3">
        <div>Test Data</div>
        <Button
          icon="pi pi-clone"
          className="p-button-text ml-2 custom-button"
          onClick={() =>
            navigator.clipboard.writeText(JSON.stringify(testData, null, 2))
          }
          tooltip="Copy test data"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    );
  };

  return (
    <Dialog
      header={headerTemplate}
      style={{
        width: "50%",
        height: "100%",
        position: "absolute",
        bottom: 0,
        right: 0,
      }}
      visible={isVisible}
      onHide={() => setIsVisible(false)}
      modal={false}
    >
      <pre>{JSON.stringify(testData, null, 2)}</pre>
    </Dialog>
  );
};

export default TestDataDialog;
